module.exports = __webpack_public_path__ + "static/media/logout.7eeb6585.svg";